module.exports = __webpack_public_path__ + "img/comic_1.0cc05591.svg";